
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import gateway from "@/lib/request/gateway";
import ModalTitle from "@/lib/model/exam/modal-title";
import Auth from "@/lib/common/auth";
import { ExamSmallItem } from "@/lib/model/exambuilder/exam-component/exam-list";
import { ExamComponent } from "@/lib/model/exambuilder/exam-component/exam";
import {
  CandidateCreateItem,
  CandidateCreateMore,
  CandidateCreateParse,
  CandidateCreateParseItem,
  CandidateCreateParseLimit,
  CandidateItem
} from "@/lib/model/exambuilder/exam-component/candidate";

@Component({
  components: {
    ModalHeader
  }
})
export default class AddMoreCandidateModal extends Vue {
  @Prop() private isVisible!: boolean;
  @Prop() private examAll!: ExamSmallItem[];
  @Prop() private paperId!: number;
  @Prop() private examName!: string;
  @Prop() private candidateCreateForm!: CandidateCreateMore;

  @Watch("isVisible")
  onIsVisibleChange() {
    this.currentData = [];
  }

  async mounted() {
    this.modalTitle.title = "批量添加候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = this.examName;
    this.candidateCreateForm.sendMessage = 1;

    if (this.paperId > 0) {
      this.candidateCreateForm.examId = this.paperId;
      this.canSelected = false;
      this.checkEmail();
    }
  }

  get token() {
    return Auth.token;
  }

  // 弹窗表单
  modalTitle: ModalTitle = new ModalTitle();
  showSelectError = false;

  @Emit("on-close-more")
  handleClose() {
    this.candidateCreateForm.sendMessage = 1;
    console.log("on-close-more");
  }

  importMCandidate() {
    if (this.candidateCreateForm.examId === 0) {
      this.showSelectError = true;
      return;
    }

    if (this.okList.length > 0) {
      if (this.isShowTable || this.isShowTable2 || this.isShowTable3) {
        this.$message.error("已超过上限，无法添加候选人");
        return;
      }

      this.candidateCreateForm.candidateList = [];

      this.okList.forEach(item => {
        const params = new CandidateCreateItem();
        params.showName = item.showName;
        params.phone = item.phone;
        params.loginId = item.phone;
        params.tagList = item.tagList;

        if (this.hasEmail) {
          params.email = item.email;
        }

        this.candidateCreateForm.candidateList.push(params);
      });

      CandidateItem.mCreate(this.candidateCreateForm).then(res => {
        if (res.code === 0) {
          this.$message.success("导入成功");
          this.handleClose();
          this.$emit("confirm");
        } else {
          this.$message.error(res.message);
        }
      });
    } else {
      this.$message.error("当前没有可添加的候选人");
    }
  }

  // 面试
  canSelected = true;
  hasEmail = false; // 是否有邮箱字段

  examSelect() {
    this.showSelectError = false;
    this.checkEmail();
  }

  checkEmail() {
    if (!this.candidateCreateForm.examId) {
      return (this.hasEmail = false);
    }

    ExamComponent.hasEmail(this.candidateCreateForm.examId).then(res => {
      if (res.code !== 0) return;

      this.hasEmail = res.data.hasEmail;
    });
  }

  // 模版下载
  downloadExcel() {
    if (this.candidateCreateForm.examId === 0) {
      this.showSelectError = true;
      return;
    }

    CandidateCreateMore.getExcel(this.candidateCreateForm.examId).then(res => {
      if (res.code !== 0) return;

      const dataUrl = res.data.ossUrl;
      const a = document.createElement("a");
      a.href = dataUrl;
      a.setAttribute("download", "批量添加候选人模板");
      a.click();
    });
  }

  // 上传并解析
  candidateCreateParse = new CandidateCreateParse();
  currentData: CandidateCreateParseItem[] = [];
  limitInfo = new CandidateCreateParseLimit();
  errorListUrl = "";

  get errorList() {
    return this.currentData.filter((e: any) => e.isOk === false);
  }

  get okList() {
    return this.currentData.filter((e: any) => e.isOk === true);
  }

  // 当日当次上传候选人错误及重复条数大于阈值
  get isShowTable() {
    return this.errorList.length > this.limitInfo.createLimit.limit;
  }

  // 当日当次上传有效候选人+当日同一公司下累计已添加的候选人大于阈值
  get isShowTable2() {
    return (
      this.okList.length + this.limitInfo.createLimit.used >
      this.limitInfo.createLimit.limit
    );
  }

  // 单场面试中，未参与面试人数超过设定阈值
  get isShowTable3() {
    return (
      this.okList.length + this.limitInfo.noAnswerLimit.used >
      this.limitInfo.noAnswerLimit.limit
    );
  }

  beforeUpload(file: File) {
    const ext = file.name.toLowerCase().split(".");
    const isExcel = ext[ext.length - 1] == "xlsx";

    if (!isExcel) {
      this.$message.error("上传文件只能是 xlsx 格式!");
      return;
    }

    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (!postRes) return;

      gateway
        .upload(postRes, file)
        .then((res: any) => {
          console.log("upload res : ", res);
          this.candidateCreateParse.examId = this.candidateCreateForm.examId;
          this.candidateCreateParse.ossUrl = res.url;
          this.candidateCreateParse.needExport = 1;
          this.candidateCreateParse.needSort = 1;
        })
        .then(() => {
          CandidateCreateParse.createParse(this.candidateCreateParse).then(
            res => {
              if (res.code === 0) {
                if (res.data.count === 0) {
                  this.$message.warning("上传文件内容为空");
                }

                this.limitInfo = res.data.limitInfo;
                this.currentData = res.data.list;
                this.errorListUrl = res.data.excelUrl;
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch((err: any) => {
          return isExcel;
        })
        .finally(() => {
          return isExcel;
        });
    });
  }

  exportError() {
    window.open(this.errorListUrl);
  }
}
